import { navigate } from 'gatsby';
import React, { FC } from 'react';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';
import SubmitButton from '@ui/molecules/SubmitButton';

import spaced from '@ui/styled/Spaced';

import { IPageProps } from '@folx-types/flow-steps';

export interface IInsuranceOutOfNetworkStepPageContent {
	title: string;
	description: string;
}

interface IInsuranceOutOfNetworkStepProps extends IPageProps {
	pageContent: IInsuranceOutOfNetworkStepPageContent;
}

const SpacedColumn = spaced<IFlexColumn>(FlexColumn);

const InsuranceOutOfNetworkStep: FC<IInsuranceOutOfNetworkStepProps> = ({ pageContent }) => {
	const { title, description } = pageContent;

	return (
		<CenteredGridItem>
			<SpacedColumn gap="lgxl" marginBottom="xl" marginTop="md">
				<HeadingText>{title}</HeadingText>
				<BasicText>{description}</BasicText>
				<SubmitButton
					variant="secondary"
					label="Back to Billing"
					onClick={() => {
						navigate(`../..`);
					}}
				/>
			</SpacedColumn>
		</CenteredGridItem>
	);
};

export default InsuranceOutOfNetworkStep;
